import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceSlug/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$workspaceSlug/inbox",
      params: { workspaceSlug: params.workspaceSlug },
    });
  },
});
